var _path, _path2, _path3, _path4, _path5, _ellipse, _path6, _path7, _path8, _path9, _ellipse2, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAntenna(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "128px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--noto",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.93 116.6c0-6.16 16.62-14.9 37.13-14.9s37.13 8.74 37.13 14.9c0 0-6.71 7.4-37.13 7.4s-37.13-7.4-37.13-7.4z",
    fill: "#94d1e0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.08 108.65c-2.77-1.39-5.62-2.61-8.55-3.6l-2.28-15.91H61.1l-1.04 13.44c-4.1 1.84-8.81 7.23-8.23 11.08c.84 5.6 10.48 6.6 25.73 4.96c3.86-.42 12.14-2.85 15.35-5.2c0 .01-2.47-3.09-5.83-4.77z",
    fill: "#82aec0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f7889",
    d: "M73.22 93.34L63.7 91.1l-.79 8.39l-12.27 1.11l1.19 13.06l23.15-5.44z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.23 91.34c-6.52 7.93-54.61 6.04-77.05-10.76S3.61 18.58 10.71 9.1l106.52 82.24z",
    fill: "#82aec0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.43 91.18c.82-1.1 1.06-2.02.81-3.35l-25.32-3s-18.58 4.79-43.97-2.99l.41 4.28c24.24 11.93 61.83 13.4 68.07 5.06z",
    fill: "#2f7889"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-53.183 65.114 48.92)",
    cx: 65.12,
    cy: 48.92,
    rx: 24.3,
    ry: 67.55,
    fill: "#fafafa"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92.91 82.97c9.26-9.26-6.47-38.45-33.55-66.71C36.96 3.87 17.24.15 11.04 8.44C3 19.19 20.69 46.02 50.55 68.38C60.09 75.52 71.11 82 80.06 86.26c5.66 1.07 10.13-.57 12.85-3.29z",
    fill: "#e0e0e0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.06 108.35l-16.26.55V71.76c4.33-1.8 9.84-.37 11.03 7.55c.65 4.32 5.23 29.04 5.23 29.04z",
    fill: "#2f7889"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.68 29.47C49.81 7.11 19.08-2.3 11.04 8.44s9.65 37.58 39.52 59.93c29.87 22.36 60.6 31.77 68.64 21.03c8.04-10.74-9.65-37.57-39.52-59.93zM117 86.73c-6.92 9.25-35.54-.48-63.92-21.73S7.3 19.04 14.22 9.79c6.92-9.25 35.54.48 63.92 21.73c28.38 21.25 45.78 45.96 38.86 55.21z",
    fill: "#82aec0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.83 113.66l-16.93-4.58l2.73-31.29c.31-4.2 2.08-6.21 4.51-6.23c3.03-.02 5.94 1.78 6.42 6.63c.43 4.35 3.27 35.47 3.27 35.47z",
    fill: "#94d1e0"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.14,
    cy: 78.24,
    rx: 2.45,
    ry: 3.27,
    opacity: 0.7,
    fill: "#2f7889"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2f7889",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M91.44 19.92L72.17 45.84"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#82aec0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M30.38 44.39l59.93-25.4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#82aec0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M93.26 20.88l-6.33 64.34"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M91.57 20.05c-2.92-2.04-2.52-3.73-1.88-4.55l5.85-7.46c.64-.82 2.26-1.44 4.74.58c2.07 1.68 2.13 3.49 1.49 4.31l-5.85 7.46c-.64.82-2.38 1.04-4.35-.34z",
    fill: "#82aec0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M91.64 17.34c-.8-.6.21-3.08 2.1-5.29s3.34-3.57 4.13-2.98c.8.6.12 2.65-1.92 5.14c-2.03 2.5-3.98 3.38-4.31 3.13z",
    fill: "#94d1e0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.22 9.79c.23-.3 2.2-2.35 1-3.21c-1.3-.92-3.17.17-4.8 2.81c-3.29 5.3.37 13.76 1.15 15.56c5.47 12.64 19.69 28.96 39 43.42c8.1 6.06 16.25 11.16 24.01 15.18c3.42 1.77 6.15 3.51 9.75 3.11c2.08-.23 2.58-1.6.82-2.48C75.71 79.44 63.42 72.74 53.08 65C24.7 43.76 7.3 19.04 14.22 9.79z",
    fill: "#94d1e0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntenna);
export default __webpack_public_path__ + "static/media/antenna.0aba6b71503198a407b94abcafa85d71.svg";
export { ForwardRef as ReactComponent };